import { selectUser } from "./auth";
import { reset } from "./globalActions";
import { createSelector, createSlice } from "@reduxjs/toolkit";
import service from "../service";
import { generateClient } from 'aws-amplify/api';
import * as subscriptions from '../graphql/subscriptions';

const client = generateClient();

const moduleName = "notification";

const initialState = {
    loading: false,
    list: [],
};

const userSlice = createSlice({
    name: moduleName,
    initialState,
    extraReducers: (builder) => {
        builder.addCase(reset, () => initialState);
    },
    reducers: {
        setLoading: (state, action) => {
            state.loading = action.payload;
        },
        setList: (state, action) => {
            state.list = action.payload;
        },
        onCreateNotification: (state, action) => {
            state.list.push(action.payload);
        },
        onUpdateNotification: (state, action) => {
            let notificationIndex = state.list.findIndex((c) => c.id === action.payload.id);
            state.list[notificationIndex] = action.payload;
        },
        onDeleteNotification: (state, action) => {
            let notificationIndex = state.list.findIndex((c) => c.id === action.payload.id);
            state.list = [...state.list.slice(0, notificationIndex), ...state.list.slice(notificationIndex + 1)];
        },
    },
});

export const { setLoading, setList, onCreateNotification, onUpdateNotification, onDeleteNotification } = userSlice.actions;
export default userSlice.reducer;

export const selectState = (state) => state[moduleName];
export const selectLoading = createSelector(selectState, (state) => state.loading);
export const selectNotifications = createSelector(selectState, (state) => state.list);

export const fetchNotificationsByUserId =
    () =>
        async (dispatch, getState) => {
            try {
                dispatch(setLoading(true));
                const { username } = selectUser(getState());
                const items = await service.notificationsByUserId(username);
                dispatch(setList(items));
            } finally {
                dispatch(setLoading(false));
            }
        };

export const createNotification = (notification) => async (dispatch) => {
    const createdNotification = await service.createNotification(notification);
    dispatch(onCreateNotification(createdNotification));
};

export const updateNotification = (notification) => async (dispatch) => {
    const updatedNotification = await service.updateNotification(notification);
    dispatch(onUpdateNotification(updatedNotification));
};

export const deleteNotification = (notification) => async (dispatch) => {
    const deletedNotification = await service.deleteNotification(notification);
    dispatch(onDeleteNotification(deletedNotification));
};

let createNotificationSubscription, deleteNotificationSubscription, updateNotificationSubscription;
export const subscribeUserNotification = (onNewNotification) => (dispatch, getState) => {
    const { username } = selectUser(getState());
    if (createNotificationSubscription) createNotificationSubscription.unsubscribe();
    if (deleteNotificationSubscription) deleteNotificationSubscription.unsubscribe();
    if (updateNotificationSubscription) updateNotificationSubscription.unsubscribe();
    createNotificationSubscription = client.graphql({
        query: subscriptions.onCreateNotification,
        variables: {
            filter: {
                userId: { eq: username }
            }
        }
    }).subscribe({
        next: ({ data: { onCreateNotification: data } }) => {
            dispatch(onCreateNotification(data))
            if (onNewNotification) onNewNotification(data);
        },
    })

    deleteNotificationSubscription = client.graphql({
        query: subscriptions.onDeleteNotification,
        variables: {
            filter: {
                userId: { eq: username }
            }
        }
    }).subscribe({
        next: ({ data: { onDeleteNotification: data } }) => {
            dispatch(onDeleteNotification(data))
        },
    })

    updateNotificationSubscription = client.graphql({
        query: subscriptions.onUpdateNotification,
        variables: {
            filter: {
                userId: { eq: username }
            }
        }
    }).subscribe({
        next: ({ data: { onUpdateNotification: data } }) => {
            dispatch(onUpdateNotification(data))
        },
    })
}

export const unsubscribeUserNotifications = () => async () => {
    console.log('cleanup');
    if (createNotificationSubscription) createNotificationSubscription.unsubscribe();
    if (deleteNotificationSubscription) deleteNotificationSubscription.unsubscribe();
    if (updateNotificationSubscription) updateNotificationSubscription.unsubscribe();
}
